import { render, staticRenderFns } from "./ListarWhatsapp.vue?vue&type=template&id=6a0a8bb1"
import script from "./ListarWhatsapp.vue?vue&type=script&lang=js"
export * from "./ListarWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports